module.exports = __webpack_public_path__ + "img/cog.658d778a.svg";